import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Dialog, Toast } from "primereact";
import { InputText } from "primereact/inputtext";

import { useForm } from "../../../Base/Hooks/useForm";
import Loader from "../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../Base/Services/ToastService";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { getLabel } from "../../../Base/Services/Language/LanguageService";

import { EditarArancel, getArancelesPorID, GuardarArancel } from "../../../API/IMEX/IMEXRequest";
import { InputTextarea } from "primereact/inputtextarea";


const ArancelesCRUD = ({showDialog, setShowDialog, selected, setSelected, getInfo }) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [titleAg, setTitleAg] = useState('');
  const [titleEd, setTitleEd] = useState('');

  const initialValues = {
    IdStatus: selected ? selected?.IdStatus : 66,
    Comentario: '',
  };


  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    if(selected[0]?.IdArancel){
        const resp = await getArancelesPorID(selected[0]?.IdArancel);
        setValues({
            ...resp[0]
        })
    }
    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false)
    setSelected([]);
  };

  const verificarInfo = () => {
    let error = {};

    if (!values?.Codigo) {
        error.Codigo = true;
        error.error = true;
    }
    if (!values?.Arancel) {
        error.Arancel = true;
        error.error = true;
    }
    
    setError(error);
    return error;
  };

  const agregarDatos = async () => {
    const e = verificarInfo();
    if (!e.error) {

        setLoading(true);
        let respuesta
        const Datos = {
            IdArancel: values?.IdArancel,
            Arancel: values?.Arancel,
            Codigo: values?.Codigo,
            Comentario: values?.Comentario,
            IdUserCreate: userAuth?.IdUser,
            IdUserEdit: userAuth?.IdUser,
        };
        if(Datos?.IdArancel > 0){
            respuesta = await EditarArancel(Datos)
        }else{
            respuesta = await GuardarArancel(Datos)
        }
 
        if (respuesta[0].ESTADO !== -1) {
            toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
            setTimeout(() => {
              onHide();
              setLoading(false);
              getInfo();
            }, 1500);
        } else {
            toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
            setLoading(false);
        }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label={getLabel(baseLang, "cancelar", config.language)}
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={!selected[0]?.IdArancel ? `${getLabel(baseLang, "btnGuardar", config.language)}` : `${getLabel(baseLang, "btnEditar", config.language)}`}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarDatos}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    getValoresIniciales()
    setTitleAg(getLabel(baseLang, "Agregar Arancel", config.language))
    setTitleEd(getLabel(baseLang, "Editar Arancel", config.language))
  }, [showDialog]);

  const dialogTitle = !selected[0]?.IdArancel ? titleAg : titleEd;

  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <Toast ref={toast} style={{ zIndex: 50000 }} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
            <div className="d-flex align-items-center mx-5">
                <h2>{dialogTitle}</h2>
            </div>

            <div style={{ width: "100", margin: "auto" }}>
                <div className="modal__input-contenedor">
                    <div className="field col-6 me-2 mt-2">
                        <span className="p-float-label">
                        <InputText
                            name="Codigo"
                            value={values.Codigo}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            className={error.Codigo ? "p-invalid" : ""}
                        />
                        <label htmlFor="Codigo">{getLabel(baseLang, "Código", config.language)}</label>
                        </span>
                    </div>

                    <div className="field col-6 me-2 mt-2">
                        <span className="p-float-label">
                        <InputText
                            name="Comentario"
                            value={values.Comentario}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            className={error.Comentario ? "p-invalid" : ""}
                        />
                        <label htmlFor="Comentario">{getLabel(baseLang, "DAI", config.language)}</label>
                        </span>
                    </div>
                </div>

                <div className="modal__input-contenedor">
                  <div className="field col-12 me-2  mt-2">
                      <span className="p-float-label">
                      <InputTextarea
                        name="Arancel"
                        value={values.Arancel}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        className={error.Arancel ? "p-invalid" : ""}
                      />
                      <label htmlFor="Arancel">{getLabel(baseLang, "Arancel", config.language)}</label>
                      </span>
                  </div>
                </div>
            </div>

        </div>
      </Dialog>
    </div>
  );
};

export default ArancelesCRUD;
